import { Component, OnInit } from "@angular/core";
import { LayoutConfigModel } from "../../../../interfaces/home/layout-config";

import { from } from "rxjs";
@Component({
  selector: "header-mobile",
  templateUrl: "./header-mobile.component.html",
  styleUrls: ["./header-mobile.component.css"]
})
export class HeaderMobileComponent implements OnInit {
  config: LayoutConfigModel;
  headerLogo: string;
  asideDisplay: boolean;

  //Wasn't Implemented to be removed later
  toggleOptions: any = {
    target: "body",
    targetState: "kt-header__topbar--mobile-on",
    togglerState: "kt-header-mobile__toolbar-topbar-toggler--active"
  };

  constructor() {}

  ngOnInit() {
    this.config = JSON.parse(localStorage.getItem("layoutConfig"));
    this.headerLogo = this.config.self.logo.sticky;
    this.asideDisplay = this.config.aside.self.display;
  }
}
